import React from 'react'
import {
  MapPinIcon,
  BriefcaseIcon,
  CalendarDaysIcon,
} from '@heroicons/react/24/outline'
import { HalfTimeBadge } from './icons/badges/HalfTimeBadge'

export type IconType =
  | 'account'
  | 'balance'
  | 'ball'
  | 'bike'
  | 'calendar'
  | 'calendarV2'
  | 'caret'
  | 'cleanAllFilters'
  | 'clock'
  | 'close'
  | 'coffee'
  | 'diploma'
  | 'edit'
  | 'emailAddress'
  | 'france'
  | 'graduation'
  | 'halfTime'
  | 'heart'
  | 'home'
  | 'homeoffice'
  | 'internship'
  | 'lama'
  | 'location'
  | 'megaphone'
  | 'mortarboard'
  | 'newspaper'
  | 'office'
  | 'parking'
  | 'pin'
  | 'plane'
  | 'planet'
  | 'play'
  | 'playV2'
  | 'salary'
  | 'salaryV2'
  | 'search'
  | 'shirt'
  | 'star'
  | 'stopwatch'
  | 'stopwatchV2'
  | 'sustainable'
  | 'upload'
  | 'user'

export type IconProps = {
  color?: 'primary' | 'secondary' | 'white' | 'black' | 'gray' | string
  icon: IconType

  className?: string
}

const Icon: React.FC<IconProps> = ({
  color = undefined,
  icon,
  className = '',
}) => {
  let colorClass = ``

  switch (color) {
    case 'primary':
      colorClass = 'text-primary'
      break
    case 'secondary':
      colorClass = 'text-secondary'
      break
    case 'black':
      colorClass = 'text-night'
      break
    case 'white':
      colorClass = 'text-white'
      break
    case 'gray':
      colorClass = 'text-gray-500'
      break
    default:
      colorClass = 'text-inherit'
  }

  if (!icon) {
    return null
  }
  let IconSvg: string | JSX.Element = ''
  switch (icon) {
    case 'account':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 239 239">
          <path
            fill="currentColor"
            d="M119.5 0A119.5 119.5 0 10239 119.5 119.64 119.64 0 00119.5 0zm70.72 196.44a3.45 3.45 0 00-.28.26l-.29.25c-.53.49-1.06 1-1.6 1.43s-1 .86-1.5 1.28l-.08.07c-.51.43-1 .85-1.54 1.26-.27.23-.55.45-.82.66s-.81.64-1.22.94q-.31.25-.63.48-.66.51-1.32 1-2.92 2.13-6 4.05c-.71.45-1.44.89-2.16 1.32l-2.22 1.29c-.73.41-1.46.81-2.19 1.19q-2.28 1.22-4.62 2.3a95.487 95.487 0 01-6.87 2.93c-.79.3-1.39.53-2.09.78l-1.2.42c-.6.21-1.21.41-1.82.6s-1.35.44-2 .64c-.7.21-1.4.41-2.11.6s-1.33.37-2 .53l-1.58.4-.62.14c-.58.14-1.15.27-1.73.39s-1.39.3-2.08.43l-1.91.35-.42.07q-.94.17-1.89.3c-.26 0-.53.09-.79.12-.44.07-.89.13-1.34.18-1.14.16-2.29.29-3.45.4-.55.06-1.1.1-1.65.14s-.83.08-1.25.1h-.15c-1.34.1-2.69.16-4 .2-1.06 0-2.13.05-3.2.05s-2.14 0-3.2-.05c-1.35 0-2.7-.1-4-.2h-.15c-.42 0-.83-.06-1.25-.1s-1.1-.08-1.65-.14c-1.16-.11-2.31-.24-3.45-.4-.45 0-.9-.11-1.34-.18-.26 0-.53-.07-.79-.12q-.94-.13-1.89-.3l-.42-.07-1.91-.35c-.69-.13-1.39-.28-2.08-.43s-1.15-.25-1.73-.39l-.62-.14-1.58-.4c-.67-.16-1.34-.34-2-.53s-1.41-.39-2.11-.6c-.69-.2-1.36-.41-2-.64s-1.22-.39-1.82-.6l-1.2-.42c-.7-.25-1.4-.51-2.09-.78s-1.57-.61-2.35-.93c-1.53-.62-3-1.28-4.52-2s-3.1-1.49-4.62-2.3c-.73-.38-1.46-.78-2.19-1.19s-1.48-.85-2.22-1.29-1.45-.87-2.16-1.32q-3.06-1.92-6-4.05-.66-.48-1.32-1l-.63-.48c-.41-.3-.82-.62-1.22-.94s-.55-.43-.82-.66c-.52-.41-1-.83-1.54-1.26l-.08-.07c-.51-.42-1-.84-1.5-1.28s-1.07-.94-1.6-1.43l-.29-.25a3.45 3.45 0 00-.28-.26 72 72 0 01141.44 0zM89.5 88.5A29.5 29.5 0 11119 118a29.53 29.53 0 01-29.5-29.5zm112.8 94.78a87.52 87.52 0 00-59.63-57.11 44.5 44.5 0 10-47 .19 87.53 87.53 0 00-58.97 56.92A104.51 104.51 0 11224 119.5a103.62 103.62 0 01-21.7 63.78z"
          />
        </svg>
      )
      break
    case 'balance':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 452.2 452.2">
          <path
            fill="currentColor"
            d="M226.1 177.58a26 26 0 1126-26 26.05 26.05 0 01-26 26zm0-41.82a15.8 15.8 0 1015.8 15.8 15.81 15.81 0 00-15.8-15.8zM131.77 294.07c-25.35 0-46.31-19.06-46.73-42.5a5.75 5.75 0 015.74-5.84h82a5.75 5.75 0 015.73 5.85c-.43 23.42-21.39 42.49-46.74 42.49zM95.7 256c2.75 15.74 18 27.89 36.07 27.89s33.32-12.19 36.07-27.89zM320.31 149.3a15.35 15.35 0 1115.35-15.3 15.37 15.37 0 01-15.35 15.3zm0-20.48a5.13 5.13 0 105.13 5.13 5.13 5.13 0 00-5.13-5.13zM131.67 183A15.35 15.35 0 11147 167.69 15.37 15.37 0 01131.67 183zm0-20.48a5.13 5.13 0 105.13 5.13 5.13 5.13 0 00-5.13-5.09z"
          />
          <path
            fill="currentColor"
            d="M246.106 142.052l63.227-11.308 1.799 10.06-63.227 11.308zM140.84 160.862l63.443-11.347 1.8 10.06-63.444 11.347zM220.99 172.47h10.22v138.17h-10.22zM90.32 248.55l36.8-73.201 9.132 4.59-36.8 73.2z"
          />
          <path
            fill="currentColor"
            d="M127.127 179.956l9.112-4.628 37.187 73.206-9.111 4.628zM320.31 260.22c-25.35 0-46.31-19.06-46.73-42.5a5.75 5.75 0 015.74-5.84h82a5.75 5.75 0 015.68 5.82c-.38 23.45-21.34 42.52-46.69 42.52zm-36.07-38.12c2.75 15.75 18 27.89 36.07 27.89s33.32-12.14 36.07-27.89z"
          />
          <path
            fill="currentColor"
            d="M278.863 214.694l36.8-73.2 9.13 4.59-36.8 73.2z"
          />
          <path
            fill="currentColor"
            d="M315.657 146.078l9.111-4.629 37.188 73.206-9.112 4.629zM299.86 337.74H154.47a5.11 5.11 0 01-5.11-5.11v-4a22.91 22.91 0 0122.88-22.88h109.84A22.92 22.92 0 01305 328.62v4a5.11 5.11 0 01-5.14 5.12zm-140.23-10.22H294.7A12.68 12.68 0 00282.08 316H172.24a12.67 12.67 0 00-12.61 11.52z"
          />
        </svg>
      )
      break
    case 'ball':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 452.2 452.2">
          <path
            fill="currentColor"
            d="M226 375.32c-81.21 0-147.28-66.07-147.28-147.28S144.83 80.76 226 80.76 373.32 146.83 373.32 228 307.25 375.32 226 375.32zM226 91c-75.54 0-137 61.46-137 137s61.46 137.1 137 137.1S363.1 303.62 363.1 228 301.61 91 226 91z"
          />
          <path
            fill="currentColor"
            d="M365.68 235.64c-81.21 0-147.28-66.06-147.28-147.27h10.23c0 75.57 61.48 137 137.05 137zM231.15 370.21h-10.22c0-75.58-61.49-137.06-137.06-137.06v-10.22c81.21 0 147.28 66.07 147.28 147.28zM119.62 133.86l6.85-7.59.02.02-6.87 7.57z"
          />
          <path
            fill="currentColor"
            d="M119.419 133.674l7.226-7.226 200.96 200.96-7.227 7.226z"
          />
          <path
            fill="currentColor"
            d="M119.419 327.393l200.96-200.96 7.226 7.227-200.96 200.96z"
          />
        </svg>
      )
      break
    case 'bike':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 452.2 452.2">
          <path
            fill="currentColor"
            d="M319.24 285.47a19 19 0 1119-19 19 19 0 01-19 19zm0-27.71a8.75 8.75 0 108.74 8.75 8.76 8.76 0 00-8.74-8.75zM237.28 298.11a19 19 0 1119-19 19 19 0 01-19 19zm0-27.71a8.75 8.75 0 108.75 8.74 8.75 8.75 0 00-8.75-8.74z"
          />
          <path
            fill="currentColor"
            d="M319.24 324.56a58.06 58.06 0 1158.06-58.05 58.12 58.12 0 01-58.06 58.05zm0-105.89a47.84 47.84 0 1047.83 47.84 47.88 47.88 0 00-47.83-47.84zM134.67 285.47a19 19 0 1119-19 19 19 0 01-19 19zm0-27.71a8.75 8.75 0 108.75 8.75 8.75 8.75 0 00-8.75-8.75z"
          />
          <path
            fill="currentColor"
            d="M134.67 324.56a58.06 58.06 0 1158.06-58.05 58.11 58.11 0 01-58.06 58.05zm0-105.89a47.84 47.84 0 1047.84 47.84 47.89 47.89 0 00-47.84-47.84zM140.64 183.63a24.65 24.65 0 010-49.3 5.12 5.12 0 110 10.23 14.42 14.42 0 100 28.84 5.12 5.12 0 110 10.23z"
          />
          <path
            fill="currentColor"
            d="M181.59 144.56h-41a5.12 5.12 0 010-10.23h41a5.12 5.12 0 010 10.23z"
          />
          <path
            fill="currentColor"
            d="M158.93 237.81a5.13 5.13 0 01-5-6.32l22.66-93.25a5.11 5.11 0 019.93 2.41L163.9 233.9a5.13 5.13 0 01-4.97 3.91z"
          />
          <path
            fill="currentColor"
            d="M140.88 259.69a5.11 5.11 0 01-3.94-8.36l18-21.89a5.11 5.11 0 017.89 6.51l-18.05 21.88a5.08 5.08 0 01-3.9 1.86zM266.53 183.63h-94.44a5.12 5.12 0 010-10.23h94.44a5.12 5.12 0 010 10.23z"
          />
          <path
            fill="currentColor"
            d="M313.38 259.08a5.12 5.12 0 01-4.35-2.42l-46.84-75.45a5.11 5.11 0 118.68-5.39l46.85 75.45a5.12 5.12 0 01-4.34 7.81z"
          />
          <path
            fill="currentColor"
            d="M241.88 270.4a5.12 5.12 0 01-4.87-6.66l36.22-114.38a5.11 5.11 0 119.74 3.08l-36.22 114.39a5.11 5.11 0 01-4.87 3.57zM228.19 273.22a5.1 5.1 0 01-4-1.93l-59.63-75a5.11 5.11 0 018-6.36l59.63 75a5.11 5.11 0 01-4 8.29zM250.94 282a5.11 5.11 0 01-.58-10.19l54.43-6.32a5.11 5.11 0 111.21 10.18L251.53 282a4 4 0 01-.59 0zM230.67 314.28a5.17 5.17 0 01-1.49-.22 5.12 5.12 0 01-3.41-6.37l4.94-16.29a5.11 5.11 0 019.78 3l-4.93 16.28a5.11 5.11 0 01-4.89 3.6z"
          />
          <path
            fill="currentColor"
            d="M241.88 314.28h-22.57a5.11 5.11 0 010-10.22h22.57a5.11 5.11 0 010 10.22zM298.55 154h-.79l-42.89-1.91c-8.36-.37-14.9-6.51-14.9-14 0-7.64 6.54-13.78 14.9-14.15l42.89-1.94c9-.48 16.47 6 16.47 14v4c0 7.72-7.03 14-15.68 14zm0-21.77h-.34l-42.89 1.92c-2.78.12-5.13 1.85-5.13 3.77 0 2.09 2.35 3.81 5.13 3.94l43.23 1.92c2.91 0 5.46-1.77 5.46-3.78v-4c-.01-2-2.55-3.77-5.46-3.77z"
          />
        </svg>
      )
      break
    case 'calendar':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            fill="currentColor"
            d="M452 40h-24V0h-40v40H124V0H84v40H60C26.9 40 0 66.9 0 100v352c0 33.1 26.9 60 60 60h392c33.1 0 60-26.9 60-60V100c0-33.1-26.9-60-60-60zm20 412c0 11-9 20-20 20H60c-11 0-20-9-20-20V188h432v264zm0-304H40v-48c0-11 9-20 20-20h24v40h40V80h264v40h40V80h24c11 0 20 9 20 20v48z"
          />
          <path
            fill="currentColor"
            d="M76 230h40v40H76zM156 230h40v40h-40zM236 230h40v40h-40zM316 230h40v40h-40zM396 230h40v40h-40zM76 310h40v40H76zM156 310h40v40h-40zM236 310h40v40h-40zM316 310h40v40h-40zM76 390h40v40H76zM156 390h40v40h-40zM236 390h40v40h-40zM316 390h40v40h-40zM396 310h40v40h-40z"
          />
        </svg>
      )
      break
    case 'calendarV2':
      IconSvg = <CalendarDaysIcon />
      break
    case 'caret':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 66.91">
          <path
            fill="currentColor"
            stroke="currentColor"
            d="M11.68 1.95a6.884 6.884 0 00-9.73.13 6.884 6.884 0 00.13 9.73l54.79 53.13 4.8-4.93-4.8 4.95a6.9 6.9 0 009.75-.15c.08-.08.15-.16.22-.24l53.95-52.76a6.875 6.875 0 00.14-9.73c-2.65-2.72-7.01-2.79-9.73-.13L61.65 50.41 11.68 1.95h0z"
          />
        </svg>
      )
      break
    case 'clock':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 452.2 452.2">
          <path
            fill="currentColor"
            d="M226.34 374c-81.56 0-147.91-66.34-147.91-147.9S144.78 78.19 226.34 78.19s147.91 66.35 147.91 147.91S307.9 374 226.34 374zm0-285.59c-75.92 0-137.69 61.76-137.69 137.68s61.77 137.69 137.69 137.69S364 302 364 226.1 302.26 88.42 226.34 88.42z"
          />
          <path
            fill="currentColor"
            d="M226.12 150.23a5.11 5.11 0 01-5.12-5.11v-26.06a5.12 5.12 0 0110.23 0v26.06a5.11 5.11 0 01-5.11 5.11zM332.66 231.21H306.6a5.11 5.11 0 010-10.22h26.06a5.11 5.11 0 010 10.22zM295.84 191.09a5.11 5.11 0 01-2.6-9.52l22.46-13.22a5.11 5.11 0 115.18 8.81l-22.45 13.22a5.08 5.08 0 01-2.59.71zM266.51 161.6a5 5 0 01-2.49-.66 5.12 5.12 0 01-2-7l12.76-22.72a5.12 5.12 0 018.92 5L271 159a5.12 5.12 0 01-4.49 2.6zM226.12 338a5.11 5.11 0 01-5.11-5.11v-7.35a5.11 5.11 0 1110.22 0v7.35a5.11 5.11 0 01-5.11 5.11zM226.11 230.2a5.11 5.11 0 01-5.11-5.11v-54.24a5.11 5.11 0 0110.22 0v54.24a5.11 5.11 0 01-5.11 5.11z"
          />
          <path
            fill="currentColor"
            d="M247.58 252a5.08 5.08 0 01-3.61-1.5l-21.25-21.24A5.11 5.11 0 11230 222l21.25 21.24a5.12 5.12 0 01-3.62 8.73zM126.08 231h-6.51a5.11 5.11 0 010-10.22h6.51a5.11 5.11 0 110 10.22zM134 284.31a5.11 5.11 0 01-2.6-9.51l6.11-3.61a5.11 5.11 0 015.19 8.81l-6.11 3.6a5.11 5.11 0 01-2.59.71zM173 323.3a5.1 5.1 0 01-4.45-7.61l3.19-5.68a5.11 5.11 0 018.91 5l-3.19 5.68a5.11 5.11 0 01-4.46 2.61z"
          />
        </svg>
      )
      break
    case 'close':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960">
          <path
            fill="currentColor"
            d="M249 849l-42-42 231-231-231-231 42-42 231 231 231-231 42 42-231 231 231 231-42 42-231-231-231 231z"
          />
        </svg>
      )
      break
    case 'coffee':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 452.2 452.2">
          <path
            fill="currentColor"
            d="M227 308.74h-1.51A79.8 79.8 0 01145.73 229v-39.57a5.11 5.11 0 015.11-5.11h150.7a5.11 5.11 0 015.11 5.11V229A79.79 79.79 0 01227 308.74zm-71-114.2V229a69.56 69.56 0 0069.48 69.48H227A69.56 69.56 0 00296.43 229v-34.5z"
          />
          <path
            fill="currentColor"
            d="M332.7 309.42a27.56 27.56 0 01-27.27 23.9H145.9a27.54 27.54 0 01-27.27-23.9H332.7m4.3-10.22H114.34a6.17 6.17 0 00-6.17 6.17v.44a37.73 37.73 0 0037.73 37.73h159.53a37.72 37.72 0 0037.72-37.73v-.44a6.17 6.17 0 00-6.15-6.17zM173 135a5.14 5.14 0 01-3.29-1.2c-12.69-10.7 1.25-32 2.88-34.4a5.11 5.11 0 018.45 5.75c-3.35 5-9.2 17.07-4.74 20.83a5.11 5.11 0 01-3.3 9z"
          />
          <path
            fill="currentColor"
            d="M169.15 162.55a5.1 5.1 0 01-4.22-8c3.35-4.95 9.2-17.06 4.74-20.82a5.11 5.11 0 116.58-7.82c12.7 10.69-1.24 32-2.87 34.39a5.1 5.1 0 01-4.23 2.25zM225.85 136a5.14 5.14 0 01-3.3-1.2c-12.69-10.7 1.25-32 2.88-34.39a5.11 5.11 0 018.45 5.75c-3.35 4.94-9.2 17.06-4.74 20.82a5.11 5.11 0 01-3.29 9z"
          />
          <path
            fill="currentColor"
            d="M222 163.57a5.11 5.11 0 01-4.23-8c3.35-5 9.2-17.06 4.74-20.82a5.11 5.11 0 116.59-7.82c12.69 10.7-1.25 32-2.88 34.39a5.1 5.1 0 01-4.22 2.25zM278.67 137a5.14 5.14 0 01-3.29-1.2c-12.7-10.7 1.24-32 2.88-34.4a5.11 5.11 0 018.45 5.75c-3.36 5-9.21 17.07-4.74 20.83a5.11 5.11 0 01-3.3 9z"
          />
          <path
            fill="currentColor"
            d="M274.8 164.59a5.11 5.11 0 01-4.23-8c3.36-5 9.2-17.06 4.74-20.82a5.11 5.11 0 016.59-7.77c12.69 10.69-1.24 32-2.88 34.39a5.1 5.1 0 01-4.22 2.2zM306.6 267.68h-15.75v-10.23h15.75a31.45 31.45 0 000-62.89h-8.12v-10.22h8.12a41.67 41.67 0 010 83.34z"
          />
        </svg>
      )
      break
    case 'diploma':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 452.2 452.2">
          <path
            fill="currentColor"
            d="M327.37 356.94h-152.8a5.11 5.11 0 110-10.22h152.8a5.11 5.11 0 110 10.22zm0-24.08a5.11 5.11 0 01-5.11-5.11V143.39a5.12 5.12 0 0110.23 0v184.36a5.11 5.11 0 01-5.12 5.11zm-24.08-208.44H126.43a5.11 5.11 0 010-10.22h176.86a5.11 5.11 0 010 10.22zm-152.78 87.21a5.11 5.11 0 01-5.11-5.11v-63.13a5.11 5.11 0 0110.22 0v63.13a5.11 5.11 0 01-5.11 5.11zm0 121.23a5.11 5.11 0 01-5.11-5.11v-73.06a5.11 5.11 0 0110.22 0v73.06a5.11 5.11 0 01-5.11 5.11zm144.93-165.32h-98a5.11 5.11 0 010-10.22h98a5.11 5.11 0 110 10.22zm0 31.19h-98a5.11 5.11 0 010-10.22h98a5.11 5.11 0 110 10.22zm0 29.88h-74.73a5.11 5.11 0 010-10.22h74.73a5.11 5.11 0 110 10.22zm0 31.19h-74.73a5.11 5.11 0 110-10.22h74.73a5.11 5.11 0 110 10.22zm0 31.2h-74.73a5.11 5.11 0 010-10.22h74.73a5.11 5.11 0 010 10.22z"
          />
          <path
            fill="currentColor"
            d="M125 299.68a5.39 5.39 0 01-1-.09 5.13 5.13 0 01-4-4l-3-15.2-15.16 3.22a5.11 5.11 0 01-5.34-7.8l25.45-38.76 8.54 5.61L111.84 271l8-1.71a5.13 5.13 0 016.08 4l1.62 8.06L146.22 253l8.54 5.61-25.44 38.75a5.13 5.13 0 01-4.32 2.32z"
          />
          <path
            fill="currentColor"
            d="M172.62 299.69a5.12 5.12 0 01-4.34-2.41l-24.5-39.37 8.68-5.4 17.93 28.81 1.83-8a5.12 5.12 0 016.17-3.84l8 1.91-17.93-28.8 8.68-5.41 24.5 39.36a5.12 5.12 0 01-5.53 7.68L181 280.6l-3.44 15.11a5.12 5.12 0 01-4.13 3.91 6.22 6.22 0 01-.81.07zm1.95 57.25a29.22 29.22 0 01-29.19-29.19 5.11 5.11 0 1110.22 0 19 19 0 0019 19 5.11 5.11 0 110 10.22zm152.8-208.44a5.11 5.11 0 01-5.11-5.11 19 19 0 00-19-19 5.11 5.11 0 010-10.22 29.23 29.23 0 0129.2 29.19 5.11 5.11 0 01-5.09 5.14z"
          />
          <path
            fill="currentColor"
            d="M150.49 259.8a29.2 29.2 0 1129.19-29.2 29.23 29.23 0 01-29.19 29.2zm0-48.17a19 19 0 1019 19 19 19 0 00-19-19zm-24.06-39.04a29.2 29.2 0 1129.19-29.2 5.11 5.11 0 01-10.22 0 19 19 0 10-19 19 5.12 5.12 0 010 10.23zm200.94 184.35a5.11 5.11 0 010-10.22 19 19 0 0018.28-13.86H203.32a29.24 29.24 0 01-28.75 24.08 5.11 5.11 0 110-10.22 19 19 0 0019-19 5.11 5.11 0 015.12-5.11h152.8a5.11 5.11 0 015.11 5.11 29.23 29.23 0 01-29.23 29.22z"
          />
          <path
            fill="currentColor"
            d="M150.49 172.59h-24.06a5.12 5.12 0 010-10.23h24.06a5.12 5.12 0 010 10.23z"
          />
        </svg>
      )
      break
    case 'edit':
      IconSvg = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.8" clipPath="url(#clip0_449_2781)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1.56561 3.23223C2.03445 2.76339 2.67033 2.5 3.33337 2.5H9.16671C9.62694 2.5 10 2.8731 10 3.33333C10 3.79357 9.62694 4.16667 9.16671 4.16667H3.33337C3.11236 4.16667 2.9004 4.25446 2.74412 4.41074C2.58784 4.56702 2.50004 4.77899 2.50004 5V16.6667C2.50004 16.8877 2.58784 17.0996 2.74412 17.2559C2.9004 17.4122 3.11236 17.5 3.33337 17.5H15C15.2211 17.5 15.433 17.4122 15.5893 17.2559C15.7456 17.0996 15.8334 16.8877 15.8334 16.6667V10.8333C15.8334 10.3731 16.2065 10 16.6667 10C17.1269 10 17.5 10.3731 17.5 10.8333V16.6667C17.5 17.3297 17.2366 17.9656 16.7678 18.4344C16.299 18.9033 15.6631 19.1667 15 19.1667H3.33337C2.67033 19.1667 2.03445 18.9033 1.56561 18.4344C1.09677 17.9656 0.833374 17.3297 0.833374 16.6667V5C0.833374 4.33696 1.09677 3.70107 1.56561 3.23223Z"
              fill="#637381"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.6667 2.39884C16.4189 2.39884 16.1812 2.49729 16.006 2.67253L8.25253 10.426L7.81203 12.188L9.57402 11.7475L17.3275 3.99402C17.5027 3.81878 17.6012 3.5811 17.6012 3.33328C17.6012 3.08545 17.5027 2.84777 17.3275 2.67253C17.1522 2.49729 16.9146 2.39884 16.6667 2.39884ZM14.8275 1.49402C15.3153 1.00622 15.9769 0.732178 16.6667 0.732178C17.3566 0.732178 18.0182 1.00622 18.506 1.49402C18.9938 1.98182 19.2678 2.64342 19.2678 3.33328C19.2678 4.02313 18.9938 4.68473 18.506 5.17253L10.5893 13.0892C10.4825 13.196 10.3487 13.2718 10.2022 13.3084L6.86884 14.1417C6.58486 14.2127 6.28445 14.1295 6.07747 13.9225C5.87049 13.7156 5.78728 13.4151 5.85827 13.1312L6.69161 9.79783C6.72824 9.65131 6.804 9.51749 6.9108 9.41069L14.8275 1.49402Z"
              fill="#637381"
            />
          </g>
          <defs>
            <clipPath id="clip0_449_2781">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case 'emailAddress':
      IconSvg = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.8">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.33337 4.16667C2.87694 4.16667 2.50004 4.54357 2.50004 5V15C2.50004 15.4564 2.87694 15.8333 3.33337 15.8333H16.6667C17.1231 15.8333 17.5 15.4564 17.5 15V5C17.5 4.54357 17.1231 4.16667 16.6667 4.16667H3.33337ZM0.833374 5C0.833374 3.6231 1.95647 2.5 3.33337 2.5H16.6667C18.0436 2.5 19.1667 3.6231 19.1667 5V15C19.1667 16.3769 18.0436 17.5 16.6667 17.5H3.33337C1.95647 17.5 0.833374 16.3769 0.833374 15V5Z"
              fill="#637381"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.983964 4.52202C1.24789 4.14498 1.7675 4.05329 2.14454 4.31722L9.99999 9.81603L17.8554 4.31722C18.2325 4.05329 18.7521 4.14498 19.016 4.52202C19.2799 4.89906 19.1882 5.41867 18.8112 5.6826L10.4779 11.5159C10.1909 11.7168 9.80904 11.7168 9.52211 11.5159L1.18877 5.6826C0.81173 5.41867 0.720035 4.89906 0.983964 4.52202Z"
              fill="#637381"
            />
          </g>
        </svg>
      )
      break
    case 'france':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240.68 243.56">
          <path
            fill="currentColor"
            d="M127.74 243.56h-20.68A9.71 9.71 0 0198 237c-.51-1.54-1.33-2.76-4-4.33a23.65 23.65 0 00-3.17-1.51 9.75 9.75 0 01-10.52 3C66.47 229.53 56 225.88 48 221.26c-12.8-7.41-15.48-16.43-15.48-22.7a9.58 9.58 0 011.5-5.13c13.49-21.58 16.3-40.31 19.13-60.08-.16-.54-.82-1.9-3.46-4.87-2.47-2.75-6.22-6.92-7.81-12.5L34.36 96 5.09 80a9.68 9.68 0 01-5-9.82v-.14l2.97-17.68a9.66 9.66 0 012.68-5.29l.09-.07c7.81-7.54 21.79-9.56 34-4.93a3.25 3.25 0 01.43.18 9.6 9.6 0 013.89 3.28c2.83 4.25 4.56 6.1 6.63 7.14a12.84 12.84 0 005.23 1 45.48 45.48 0 00-2.27-14.51 9.55 9.55 0 01.69-7.53 9.65 9.65 0 015.12-4.49c.56-.27 1.12-.56 1.67-.84a30.63 30.63 0 019.64-3.53 6.91 6.91 0 012.08 0l.31.06c2.36.39 7.89 1.32 10.21 6.86a3.8 3.8 0 01.18.47c.85 2.55 3.12 5 6.54 7.27a25.55 25.55 0 019-7.32c4.66-2.32 10.08-3.7 16.1-4.87V9.51a9.46 9.46 0 018.2-9.37 6.84 6.84 0 011.31-.14h14.77a9.69 9.69 0 019.26 7.18c.72 2.28 8.48 7.82 12.18 10.48 7.6 5.43 16.16 12 22.8 21.83a178.79 178.79 0 0127.34 7.62c13 4.82 21.53 9.5 26.75 14.72a9.71 9.71 0 01.87 12.54c-2.66 3.56-3.31 7.87-4 14.55-.71 6.39-2.28 15.81-7.65 23.74-.12.18-.26.36-.4.53l-20.56 24.67 4.37 1.45a9.62 9.62 0 016 6c5.48 16.42 4.13 27.29 1.88 40.2l3.25.82a9.7 9.7 0 017.22 9.27c0 10.75-7.4 19.48-13.61 24.92-8.28 7.24-17.33 11.23-25.49 11.23-12.14 0-20.61-4.26-28-8.85l-.54-.34c-4.54-2.84-7.41-4.56-10.45-5.17l-11.58 7.68-2.14 10.77a9.62 9.62 0 01-9.2 7.72zm-3.62-10.31zm-13.56-.47zM87.87 216.4a6.47 6.47 0 012.15.36 58.2 58.2 0 0110.85 4.55 21.43 21.43 0 018.69 9h15.14l2.09-10.55a6.65 6.65 0 012.84-4.22L145.5 205a6.51 6.51 0 013.94-1.09c7.53.32 13 3.76 18.84 7.4l.53.33c5.54 3.46 11.72 6.84 21 6.84 4.88 0 11-2.9 16.78-8 4.7-4.12 7.71-8.35 8.72-12.19l-6.06-1.52a6.61 6.61 0 01-4.91-7.55l.56-3.2c2.35-13.25 3.81-21.47-.32-34.83l-11.79-3.93a6.61 6.61 0 01-3-10.51L216.31 105c3.59-5.48 4.73-12.61 5.28-17.53.64-5.78 1.36-12.22 4.76-18.19-4.13-3.15-10.76-6.42-19.77-9.76A167.11 167.11 0 00178.64 52a6.65 6.65 0 01-4.5-3.09c-5.52-9.12-13.3-15.11-20.8-20.47-8-5.72-13.77-10.11-16.3-15.19h-8.59v17.54a6.62 6.62 0 01-5.45 6.52c-7.19 1.24-13.5 2.45-17.92 4.66a10.63 10.63 0 00-5.75 6.27 6.62 6.62 0 01-9 4.21C81 48.4 74.61 42.77 71.73 36.09a27.53 27.53 0 00-4.51 2c1.94 7 2.05 12.91 2.07 21.86a6.61 6.61 0 01-5.85 6.58c-7.91.93-14 .26-18.58-2-5-2.51-8.32-6.63-11-10.5-6.55-2.08-13.85-1.36-18 1.76L13.6 69.57l29.25 16a6.63 6.63 0 013 3.48l8.49 22.61c.07.2.14.41.2.62.71 2.68 3.08 5.32 5 7.43 3.54 4 6.8 8.38 6.87 13.75a7 7 0 01-.07 1c-2.89 20.27-5.89 41.22-20.57 65.12.2 2 1.41 5.95 8.85 10.25 6.35 3.68 15.61 7 27 10.83L82 220a6.62 6.62 0 015.87-3.6zm-7.63 7a.56.56 0 010 .08zm4.31-1.78zm-39.32-21.18v.06zM228.57 71.18zm-.34-4.77zm-106.4-35.62zm17.73-17.56z"
          />
        </svg>
      )
      break
    case 'graduation':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 269.95 249">
          <path
            fill="currentColor"
            d="M161.57 144.27a6.49 6.49 0 01-3-.74l-23.84-12.39-.17-.09a.92.92 0 00-.91 0l-.16.09-23.84 12.39a6.5 6.5 0 01-9.4-6.87l4.57-26.5v-.18a.74.74 0 00-.22-.69L85.32 90.35A6.5 6.5 0 0189 79.28l26.5-3.81a1.52 1.52 0 001.06-.74l11.76-24.09a6.5 6.5 0 0111.68 0l11.76 24.09a1.51 1.51 0 001.09.74l26.47 3.81a6.49 6.49 0 013.62 11.07l-19.25 18.88-.06.06a.74.74 0 00-.22.69v.18l4.57 26.5a6.51 6.51 0 01-6.4 7.61zm-20.77-24.63l12.13 6.36-2.33-13.5a13.68 13.68 0 014-12.53l9.85-9.65-13.49-1.94a14.56 14.56 0 01-10.74-7.6l-.09-.17-6-12.25-6 12.25-.09.17a14.56 14.56 0 01-10.71 7.6l-13.52 1.94 9.87 9.68a13.61 13.61 0 013.94 12.5l-2.33 13.5 12.12-6.31a13.85 13.85 0 0113.39-.05zm18.29-15zM59.57 249a6.36 6.36 0 01-.87-.06 6.5 6.5 0 01-5.53-5.28l-7.24-39.84-38.43 6A6.5 6.5 0 011.72 199L52 144.52a6.5 6.5 0 019.55 8.82L23.94 194.1l26.24-4.1a6.48 6.48 0 017.4 5.25l4.79 26.33 22.05-46.12a6.5 6.5 0 0111.73 5.61L65.43 245.3a6.51 6.51 0 01-5.86 3.7zM210.38 249a6.5 6.5 0 01-5.86-3.7l-30.72-64.23a6.5 6.5 0 1111.72-5.61l22.06 46.12 4.79-26.33a6.47 6.47 0 017.39-5.25l26.24 4.1-37.63-40.76a6.5 6.5 0 019.55-8.82l50.3 54.48a6.5 6.5 0 01-5.78 10.83l-38.42-6-7.24 39.84a6.5 6.5 0 01-5.54 5.28 6.11 6.11 0 01-.86.05z"
          />
          <path
            fill="currentColor"
            d="M134.28 191.75a95.88 95.88 0 1195.87-95.88 96 96 0 01-95.87 95.88zm0-178.75a82.88 82.88 0 1082.87 82.87A83 83 0 00134.28 13z"
          />
        </svg>
      )
      break

    case 'halfTime':
      IconSvg = (
        <HalfTimeBadge className={className || ''} colorClass={colorClass} />
      )
      break
    case 'heart':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 261.34 243">
          <path
            fill="currentColor"
            d="M130.62 243a21.74 21.74 0 01-16-7L21.66 135.26C-7.22 104-7.22 54.93 21.67 23.68a73.16 73.16 0 01107.78 0l1.21 1.32 1.11-1.21A73.71 73.71 0 01185.72.12a73.72 73.72 0 0153.94 23.65c28.91 31.29 28.91 80.3 0 111.59L146.62 236c-.38.41-.78.81-1.19 1.2a21.74 21.74 0 01-14.81 5.8zM75.56 14.21A58.62 58.62 0 0032.1 33.33a68.37 68.37 0 000 92.29l92.94 100.75a7.54 7.54 0 005.27 2.43 7.63 7.63 0 005.45-2l.42-.42 93-100.66a68.32 68.32 0 000-92.29 59.11 59.11 0 00-87 0l-6.33 6.87a7.11 7.11 0 01-5.23 2.3 7.09 7.09 0 01-5.22-2.29l-6.43-7a58.61 58.61 0 00-43.41-19.1z"
          />
        </svg>
      )
      break
    case 'homeoffice':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 452.2 452.2">
          <path
            fill="currentColor"
            d="M279.31 364.77H172.66a5.11 5.11 0 01-5.11-5.11v-2.94a18.17 18.17 0 0118.15-18.15h80.57a18.17 18.17 0 0118.15 18.15v2.94a5.11 5.11 0 01-5.11 5.11zm-101.23-10.23h95.81a7.94 7.94 0 00-7.62-5.75H185.7a7.93 7.93 0 00-7.62 5.75zM361.11 317H91.74a5.11 5.11 0 01-5.11-5.11V122.33a5.11 5.11 0 015.11-5.11h269.37a5.11 5.11 0 015.12 5.11v189.51a5.11 5.11 0 01-5.12 5.16zM96.85 306.72H356V127.44H96.85z"
          />
          <path
            fill="currentColor"
            d="M91.74 274.58h269.37v10.22H91.74zM257.59 253.29h-63a5.11 5.11 0 01-5.11-5.11V193h10.22v50.09h52.78V193h10.22v55.2a5.11 5.11 0 01-5.11 5.09z"
          />
          <path
            fill="currentColor"
            d="M180.59 213.19a5.11 5.11 0 01-3.62-8.72L222.48 159a5.26 5.26 0 017.22 0l45.51 45.51a5.11 5.11 0 11-7.23 7.22l-41.89-41.88-41.89 41.84a5.08 5.08 0 01-3.61 1.5zM237.49 253.29h-22.13a5.11 5.11 0 01-5.11-5.11V228a11.87 11.87 0 0111.86-11.86h8.64A11.87 11.87 0 01242.6 228v20.16a5.11 5.11 0 01-5.11 5.13zm-17-10.22h11.9V228a1.64 1.64 0 00-1.63-1.64h-8.64a1.64 1.64 0 00-1.63 1.64zM245.74 348.79h-39.66a5.11 5.11 0 01-5.11-5.11v-31.84a5.11 5.11 0 015.11-5.12h39.66a5.11 5.11 0 015.11 5.12v31.84a5.11 5.11 0 01-5.11 5.11zm-34.55-10.22h29.44V317h-29.44z"
          />
        </svg>
      )
      break
    case 'internship':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 452.2 452.2">
          <path
            fill="currentColor"
            d="M176.64 210a16.67 16.67 0 1116.67-16.67A16.69 16.69 0 01176.64 210zm0-23.12a6.45 6.45 0 106.44 6.45 6.45 6.45 0 00-6.44-6.46zM199.67 247.73h-45.92a5.11 5.11 0 01-5.11-5.11v-11.78a16.24 16.24 0 0116.22-16.22h23.71a16.23 16.23 0 0116.21 16.22v11.78a5.11 5.11 0 01-5.11 5.11zm-40.81-10.23h35.7v-6.66a6 6 0 00-6-6h-23.7a6 6 0 00-6 6z"
          />
          <path
            fill="currentColor"
            d="M275.73 362.16H122.58a5.11 5.11 0 01-5.11-5.11V147.84a5.11 5.11 0 015.11-5.12h153.15a5.11 5.11 0 015.11 5.12v209.21a5.11 5.11 0 01-5.11 5.11zm-148-10.23h142.89V153H127.69z"
          />
          <path
            fill="currentColor"
            d="M302.68 336.84a5.11 5.11 0 01-5.12-5.11v-204.1h-148a5.11 5.11 0 010-10.22h153.12a5.11 5.11 0 015.11 5.11v209.21a5.11 5.11 0 01-5.11 5.11z"
          />
          <path
            fill="currentColor"
            d="M329.62 311.53a5.11 5.11 0 01-5.11-5.11v-204.1h-148a5.11 5.11 0 110-10.22h153.11a5.11 5.11 0 015.12 5.11v209.21a5.11 5.11 0 01-5.12 5.11zM242.92 278.87h-89.17a5.11 5.11 0 010-10.22h89.17a5.11 5.11 0 010 10.22zM242.92 303.59h-89.17a5.11 5.11 0 010-10.22h89.17a5.11 5.11 0 010 10.22zM242.92 328.3h-89.17a5.11 5.11 0 010-10.22h89.17a5.11 5.11 0 110 10.22z"
          />
        </svg>
      )
      break
    case 'lama':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 270.97 242.85">
          <path
            fill="currentColor"
            d="M270.05 57.19a39.41 39.41 0 00-37.13-31.44l-33.27-1.55h-.59a35.49 35.49 0 00-67.94 2.26l-19.76 74.77c-47.78-3.45-74-1.58-86.47 6a46.34 46.34 0 00-23.38 52.7.75.75 0 00.05.16.53.53 0 000 .12L18 214.91c5.09 17 21 27.94 40.4 27.94 19.45 0 35.31-11 40.4-27.94l7.67-25.55 7.66 25.55c5.09 17 21 27.94 40.4 27.94s35.31-11 40.4-27.93l16.5-54.7a.61.61 0 000-.13.75.75 0 00.05-.16l2.13-8.06c4.93-18.66 6.52-29.33 5.46-40a168.91 168.91 0 0028.3-9.88l.32-.15 1.4-.71a39.41 39.41 0 0020.96-43.94zm-137.52 62.13c17.73.55 43.12.69 69.73-3.88.41 7.26-.84 15.86-5.12 32.07l-2 7.52c-.08.24-.15.48-.21.74L178.58 210c-2.18 7.28-9.79 15.77-24 15.77s-21.85-8.49-24-15.77l-12-39.91a12.69 12.69 0 00-24.11 0L82.45 210c-2.18 7.28-9.79 15.77-24 15.77s-21.85-8.5-24-15.77L18 155.49a29.13 29.13 0 0115-33.19c.25-.13.48-.26.71-.41 6.28-4 25.89-7.79 83.36-3.24-.07 0 5.56.35 15.46.67zm108.86-33.44l-1.24.63A158.62 158.62 0 01207.88 97a1.25 1.25 0 00-.19 0h-.19c-27.94 6-55.86 5.51-74.7 5.21l-4-.07 18.87-71.38c2.66-10.11 10.94-13.71 17.79-13.71s15.12 3.6 17.79 13.71a8.68 8.68 0 00.33 1c1.33 3.34 5.09 9 15.3 9.5l33.28 1.54c12.92.6 19.43 9.68 21.21 18s-.45 19.2-11.98 25.08z"
          />
          <circle fill="currentColor" cx="193.57" cy="61.91" r="9.47" />
        </svg>
      )
      break
    case 'location':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 247.54 243.32">
          <path
            fill="currentColor"
            d="M123.71 222.21A97.18 97.18 0 11220.89 125a97.28 97.28 0 01-97.18 97.21zm0-180.28a83.1 83.1 0 1083.1 83.1 83.2 83.2 0 00-83.1-83.1z"
          />
          <circle fill="currentColor" cx="124.41" cy="125.74" r="51.41" />
          <path
            fill="currentColor"
            d="M123.07 34.87a7.05 7.05 0 01-7-7V7a7 7 0 0114.09 0v20.82a7 7 0 01-7.09 7.05zm0 208.45a7.05 7.05 0 01-7-7v-20.83a7 7 0 0114.09 0v20.79a7 7 0 01-7.09 7.04zM27.82 132.93H7a7 7 0 010-14.09h20.82a7 7 0 110 14.09zm212.68 0h-20.78a7 7 0 010-14.09h20.78a7 7 0 010 14.09z"
          />
        </svg>
      )
      break
    case 'megaphone':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 270.6 219.6">
          <path
            d="M25.9 69.8v71.7c-5.3-1.1-12.7-15.1-12.7-35.8s7.4-34.8 12.7-35.9z"
            fill="none"
          />
          <path
            fill="currentColor"
            d="M201.1 63.4c-2.6-13.6-9-37.7-22.3-45.9-1.8-1.1-4.1-1.3-6-.4L95 50.7H32.4c-3.4 0-6.3 2.7-6.5 6.1C11.2 57.3.2 78.2.2 105.7s11.1 48.4 25.9 48.9c.6 3 3.3 5.2 6.4 5.2h13v53.4c0 3.6 2.9 6.5 6.5 6.5h27.5c3.6 0 6.5-2.9 6.5-6.5v-53.4h9l78.4 35.1c2.1.9 4.4.7 6.3-.6 12.5-8.5 18.6-31.2 21.2-44 2.8-14.5 4.2-29.3 4.1-44.1 0-14.4-1.3-28.7-3.9-42.8zM25.9 141.5c-5.3-1.1-12.7-15.1-12.7-35.8s7.4-34.8 12.7-35.8v71.6zm13 5.3V63.7h51v83.1h-51zm34 59.8H58.4v-46.9h14.5v46.9zm115.2-58.8c-3.6 17.9-8.8 28.6-13.2 33.5l-72-32.2V61.4l71.5-30.9c4.7 4.8 10.3 15.9 14 35.3 2.5 13.3 3.7 26.8 3.6 40.4 0 14-1.3 27.9-3.9 41.6zM225.5 55.8c-3.6 0-6.5-2.9-6.5-6.5 0-2.7 1.7-5.2 4.3-6.1l37.5-13.4c3.4-1.2 7.1.6 8.3 3.9 1.2 3.4-.6 7.1-3.9 8.3l-37.5 13.4c-.8.3-1.5.4-2.2.4zM261.9 180.8c-.7 0-1.5-.1-2.2-.4L222.2 167c-3.4-1.2-5.1-4.9-3.9-8.3 1.2-3.4 4.9-5.1 8.3-3.9l37.5 13.4c3.4 1.2 5.1 4.9 3.9 8.3-.9 2.6-3.3 4.3-6.1 4.3z"
          />
          <path
            fill="currentColor"
            d="M162.9 160.8c-.7 0-1.5-.1-2.2-.4L123.2 147c-3.4-1.2-5.1-4.9-3.9-8.3 1.2-3.4 4.9-5.1 8.3-3.9l37.5 13.4c3.4 1.2 5.1 4.9 3.9 8.3-.9 2.6-3.3 4.3-6.1 4.3zM264.1 111.1h-39.8c-3.6 0-6.5-2.9-6.5-6.5s2.9-6.5 6.5-6.5h39.8c3.6 0 6.5 2.9 6.5 6.5s-2.9 6.5-6.5 6.5zM-1658 0z"
          />
        </svg>
      )
      break
    case 'mortarboard':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 284.5 221.23">
          <path
            fill="currentColor"
            d="M281.29 79.64L178.41 19.27 178 19 147.1.89a6.51 6.51 0 00-6.58 0L6.34 79.64a6.5 6.5 0 00.08 11.26l6.76 3.83v24.8C5.51 122.48 0 130.53 0 140v28.9a6.5 6.5 0 006.5 6.5h25.16a6.49 6.49 0 006.5-6.48l.05-30.19a21.41 21.41 0 00-6-15.11 18.36 18.36 0 00-6-4v-17.51l22.59 12.83a6 6 0 00-.06.85V184a6.53 6.53 0 002.34 5c.92.76 22.88 18.8 56.78 27.6a142.36 142.36 0 0035.75 4.63c27.33 0 59.9-8.17 93.28-34.93a6.49 6.49 0 002.43-5.07v-67.16l41.83-23.13a6.51 6.51 0 00.14-11.3zM25.17 162.4H13V140c0-4.69 3.05-8.66 6.66-8.66a4.74 4.74 0 013.31 1.5 8.29 8.29 0 012.24 5.9zm201.15 15.68c-35.68 27.64-74.26 36.41-114.71 26.06a150.78 150.78 0 01-49.87-23.35v-58.52L138.91 166a6.52 6.52 0 003.2.85 6.41 6.41 0 003.15-.82l81.06-44.82zm-84.17-25.14L22.9 85.3l-.17-.1h-.1L143.81 14 162 24.73 79.21 73.4a6.49 6.49 0 106.58 11.2l89.08-52.34 90 52.82z"
          />
        </svg>
      )
      break
    case 'newspaper':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 252 229">
          <path
            fill="currentColor"
            d="M102 117.71H32.92a6.5 6.5 0 01-6.5-6.5V37.55a6.5 6.5 0 016.5-6.5H102a6.5 6.5 0 016.5 6.5v73.66a6.5 6.5 0 01-6.5 6.5zm-62.6-13h56.1V44.05H39.42z"
          />
          <path
            fill="currentColor"
            d="M207.34 229H44.47C20 229 0 207.93 0 182V6.5A6.5 6.5 0 016.5 0h203.92a6.5 6.5 0 016.5 6.55L216.74 30l28.11-2.83a6.51 6.51 0 017.15 6.46v148.19c0 26.02-20 47.18-44.66 47.18zM13 13v169c0 18.73 14.12 34 31.47 34h162.87c17.46 0 31.66-15.33 31.66-34.18v-141l-22.36 2.25-1.07 141.85a6.51 6.51 0 01-6.5 6.45 6.5 6.5 0 01-6.45-6.55L203.87 13z"
          />
          <path
            fill="currentColor"
            d="M178.78 51.27h-52.34a6.24 6.24 0 01-5.94-6.5 6.24 6.24 0 015.94-6.5h52.34a6.25 6.25 0 015.95 6.5 6.25 6.25 0 01-5.95 6.5zM178.78 83.05h-52.34a6.53 6.53 0 010-13h52.34a6.53 6.53 0 010 13zM178.78 110.49h-52.34a6.53 6.53 0 010-13h52.34a6.53 6.53 0 010 13zM178.58 144.82H32.92a6.5 6.5 0 010-13h145.66a6.5 6.5 0 010 13zM178.58 175.15H32.92a6.5 6.5 0 110-13h145.66a6.5 6.5 0 010 13z"
          />
        </svg>
      )
      break
    case 'office':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 318.59 243.92">
          <path
            fill="currentColor"
            d="M198.69 82.48a32.95 32.95 0 1132.94-32.95 33 33 0 01-32.94 32.95zm0-52.89a19.95 19.95 0 1019.94 19.94 20 20 0 00-19.94-19.94zM312.1 243.92h-.1l-81.4-1.61a6.5 6.5 0 01.26-13l81.39 1.61a6.5 6.5 0 01-.12 13z"
          />
          <path
            fill="currentColor"
            d="M279.41 241.14a6.5 6.5 0 01-6.5-6.5v-76.55a6.5 6.5 0 1113 0v76.55a6.5 6.5 0 01-6.5 6.5z"
          />
          <path
            fill="currentColor"
            d="M279.41 164.59c-15.61 0-27.38-21.94-27.38-51s11.77-51 27.38-51 27.38 21.94 27.38 51-11.79 51-27.38 51zm0-89.07c-5.86 0-14.38 14.82-14.38 38s8.52 38 14.38 38 14.38-14.82 14.38-38-8.52-38-14.38-38zM32.48 127.12a6.5 6.5 0 010-13l64.28-.12a6.5 6.5 0 010 13l-64.29.11zM32.48 97.89a6.5 6.5 0 010-13l64.29-.11a6.5 6.5 0 010 13l-64.29.11zM32.48 68.67a6.5 6.5 0 010-13l64.29-.11a6.5 6.5 0 010 13l-64.29.11zM32.48 39.44a6.5 6.5 0 010-13l64.29-.11a6.5 6.5 0 010 13l-64.29.11zM206.91 164.7l-83.37-.11a6.5 6.5 0 110-13l83.38.11a6.5 6.5 0 010 13zM158.62 192.52l-35.09-.11a6.5 6.5 0 010-13l35.09.11a6.5 6.5 0 010 13z"
          />
          <path
            fill="currentColor"
            d="M123.53 242.31H6.5a6.5 6.5 0 01-6.5-6.5V6.5A6.5 6.5 0 016.5 0h117a6.5 6.5 0 016.5 6.5v229.31a6.5 6.5 0 01-6.47 6.5zM13 229.31h104V13H13z"
          />
          <path
            fill="currentColor"
            d="M230.7 242.31H123.41a6.5 6.5 0 01-6.5-6.5V130.26a6.5 6.5 0 016.5-6.5H230.7a6.5 6.5 0 016.5 6.5v105.55a6.5 6.5 0 01-6.5 6.5zm-100.79-13h94.29v-92.55h-94.29z"
          />
        </svg>
      )
      break
    case 'parking':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 452.2 452.2">
          <path
            fill="currentColor"
            d="M130 314.57a15.13 15.13 0 1115.13-15.13A15.14 15.14 0 01130 314.57zm0-20a4.91 4.91 0 104.91 4.91 4.91 4.91 0 00-4.91-4.95z"
          />
          <path
            fill="currentColor"
            d="M130 333.28a33.84 33.84 0 1133.84-33.84A33.88 33.88 0 01130 333.28zm0-57.45a23.62 23.62 0 1023.62 23.61A23.64 23.64 0 00130 275.83zM303.7 314.57a15.13 15.13 0 1115.13-15.13 15.14 15.14 0 01-15.13 15.13zm0-20a4.91 4.91 0 104.91 4.91 4.91 4.91 0 00-4.91-4.95z"
          />
          <path
            fill="currentColor"
            d="M303.7 333.28a33.84 33.84 0 1133.84-33.84 33.88 33.88 0 01-33.84 33.84zm0-57.45a23.62 23.62 0 1023.62 23.61 23.63 23.63 0 00-23.62-23.61z"
          />
          <path
            fill="currentColor"
            d="M351.45 308.9H332.1a5.12 5.12 0 110-10.23h19.35a14 14 0 0013.95-13.95v-39a14 14 0 00-13.95-14h-20.08A46.77 46.77 0 01295.45 215l-20.94-25a49 49 0 00-37.68-17.59H131.5a36.73 36.73 0 00-28.75 13.77l-22.31 27.69a27.85 27.85 0 00-6.13 17.39v53.46a14 14 0 0014 13.95h13a5.12 5.12 0 010 10.23h-13a24.21 24.21 0 01-24.18-24.18v-53.46a38.12 38.12 0 018.38-23.8l22.31-27.72a46.91 46.91 0 0136.72-17.59h105.29a59.22 59.22 0 0145.52 21.26l20.94 25a36.54 36.54 0 0028.08 13.11h20.08a24.2 24.2 0 0124.17 24.18v39a24.2 24.2 0 01-24.17 24.2z"
          />
          <path
            fill="currentColor"
            d="M275 308.9H158.06a5.12 5.12 0 010-10.23H275a5.12 5.12 0 010 10.23zM331.37 231.73H108.61a12.16 12.16 0 01-9.06-20.29l17-21.81c.09-.12.19-.24.29-.35A29.48 29.48 0 01138.3 180H277a5.11 5.11 0 010 10.22H138.3a19.19 19.19 0 00-13.81 5.89l-17 21.78-.3.35a1.94 1.94 0 001.42 3.27h222.76a5.11 5.11 0 110 10.22z"
          />
          <path
            fill="currentColor"
            d="M198 231.73a5.11 5.11 0 01-5.11-5.11v-41.51a5.11 5.11 0 0110.22 0v41.51a5.11 5.11 0 01-5.11 5.11zM222.88 256.55h-20.06a5.11 5.11 0 110-10.22h20.06a5.11 5.11 0 110 10.22zM250.12 288H182.2a5.11 5.11 0 110-10.22h67.92a5.11 5.11 0 010 10.22zM370.51 288h-17a5.11 5.11 0 110-10.22h17a5.11 5.11 0 010 10.22zM93.59 288H82.46a5.11 5.11 0 110-10.22h11.13a5.11 5.11 0 010 10.22zM340.06 231.73a5.11 5.11 0 01-5.11-5.11v-49.55a5.11 5.11 0 0110.22 0v49.55a5.11 5.11 0 01-5.11 5.11z"
          />
          <path
            fill="currentColor"
            d="M371.06 182.18h-60.53a5.11 5.11 0 01-5.11-5.11v-60.54a5.11 5.11 0 015.11-5.11h60.53a5.11 5.11 0 015.11 5.11v60.54a5.11 5.11 0 01-5.11 5.11zM315.64 172H366v-50.36h-50.36z"
          />
          <path
            fill="currentColor"
            d="M352.23 146.44a9.62 9.62 0 01-4 3.78 14.07 14.07 0 01-6.68 1.44h-4.93v11.7h-7.94v-32.59h12.87a14.77 14.77 0 016.59 1.34 9.31 9.31 0 014 3.72 10.87 10.87 0 011.34 5.43 10.49 10.49 0 01-1.25 5.18zm-7.89-2.16a4.66 4.66 0 000-6 4.74 4.74 0 00-3.39-1.06h-4.32v8.17H341a4.74 4.74 0 003.34-1.11z"
          />
        </svg>
      )
      break
    case 'pin':
      IconSvg = <MapPinIcon />
      break
    case 'plane':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 269.67 219.68">
          <path
            fill="currentColor"
            d="M252.36 2.9c-.14-.19-.26-.37-.41-.55.16.21.31.43.47.66zm.17.29a1.74 1.74 0 00-.11-.18l.34.57a3.64 3.64 0 00-.23-.39z"
          />
          <path
            fill="currentColor"
            d="M269.64 201.09L254 8.1V8a2.64 2.64 0 000-.28v-.5a.15.15 0 010-.07c0-.13 0-.27-.07-.41s0-.09 0-.14l-.06-.27a.1.1 0 000-.07l-.12-.55c0-.13-.09-.25-.13-.38a1.81 1.81 0 00-.09-.31.37.37 0 00-.05-.11 3.29 3.29 0 00-.16-.44 1.17 1.17 0 000-.11c0-.1-.1-.21-.14-.31l-.12-.24c0-.06-.07-.11-.09-.16l-.55-.65c-.16-.23-.31-.45-.47-.66a.44.44 0 00-.09-.11c-.08-.08-.14-.16-.21-.24a1.62 1.62 0 00-.18-.19l-.25-.24a.43.43 0 00-.09-.1 4.29 4.29 0 00-.35-.28 3.16 3.16 0 00-.27-.2.49.49 0 00-.15-.1l-.2-.13-.11-.05a3.17 3.17 0 00-.41-.21l-.13-.06a.21.21 0 00-.12 0l-.17-.07h-.07l-.33-.1h-.08l-.28-.07h-2.36a.44.44 0 00-.16.06.85.85 0 00-.28.1h-.08l-.21.1a1.24 1.24 0 00-.2.1l-.16.09L4.12 126.88c-2.57 1.35-4.22 4.7-4.11 8.35s2 6.83 4.59 7.9l70.83 28.79L95 215.16c.07.17.14.33.22.49l.19.38c.1.2.22.39.34.58s.3.44.46.65a6.68 6.68 0 00.49.57c.15.16.3.31.47.46.17.13.33.26.5.37l.19.13a4.79 4.79 0 001 .51 5.05 5.05 0 00.55.18h.08l.5.09a.26.26 0 00.12 0 3.31 3.31 0 00.55 0 2.42 2.42 0 00.38 0h.26l.34-.06.45-.11.15-.05.38-.14.25-.11 52.44-22 1.23-.52 1.06.14 104.87 13.84a5.7 5.7 0 005.27-2.51 10.46 10.46 0 001.9-6.96zm-70.9-157.67L78.6 155.18l-52.45-21.31zM88.4 167.1l108-100.42L101.92 197zm111.21-80L152 180.47l-28.88 12.13zm-32.08 93.65L242.92 33l12.94 159.44zM246.26.15h.13-.13zM246.76.05h.11-.45zM248.42.09a3.09 3.09 0 00-.52-.09l.38.05z"
          />
          <path
            fill="currentColor"
            d="M245.2.54h.1a1.24 1.24 0 00-.2.1zM247.13 0h-.26.26zM157.66 196.75a5.1 5.1 0 01-1.95.39h-.34l1.23-.52z"
          />
          <path
            fill="currentColor"
            d="M245.3.5a1.24 1.24 0 00-.2.1h.06zM246.39.13h-.36a.68.68 0 01.23-.07zM246.76.05h.11-.19a.15.15 0 00.08 0zM247.13 0h-.26.26zM252.76 3.58l-.34-.58c-.16-.23-.31-.45-.47-.66.15.18.27.36.41.55a2.19 2.19 0 01.17.29 3.64 3.64 0 01.23.4z"
          />
        </svg>
      )
      break
    case 'planet':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 452.2 452.2">
          <path
            fill="currentColor"
            d="M121 264.25a25.6 25.6 0 01-5.8-.66l2.29-10c11.57 2.67 27.58-8.86 48.9-35.24 6-7.43 8.65-13.62 7.22-17s-7.54-5.1-12.32-5.51c-10.83-.94-28.65-13.53-26.72-54.76l10.21.48c-1.63 34.8 12 43.63 17.39 44.1 5 .43 16.91 2.43 20.85 11.69 3.13 7.36.29 16.32-8.68 27.41-21.74 27.01-38.51 39.49-53.34 39.49zM260.73 215.88a34.22 34.22 0 01-10.64-1.68c-9.79-3.18-22.77-12.44-29-38.48-8.37-35.19 31.46-64.78 33.16-66l6 8.25c-.37.27-36 26.84-29.26 55.4 4 17 11.71 27.73 22.18 31.13 10.64 3.46 21.6-1.47 27.75-6.75 4.83-4.13 7.43-9.58 10-14.86 3.08-6.44 6.26-13.09 13.41-15.28 6.38-2 14.31.17 25.71 6.87l-5.18 8.81c-10.42-6.12-15.31-6.6-17.54-5.9-2.72.83-4.5 4.31-7.18 9.91s-6.06 12.68-12.52 18.21-16.18 10.37-26.89 10.37zM216.93 329.83l-10.22-.08c.13-14.93 3.9-25.92 11.21-32.67 10.33-9.53 25.13-8.47 34.92-7.77 1.92.14 3.71.27 5.27.3 5.35.06 6.13-1.65 7.84-8.43a34.15 34.15 0 013.86-10.28 16.12 16.12 0 0110.69-7.23c15.13-3 37.1 11.72 39.55 13.42l-5.82 8.41c-7.9-5.45-23.53-13.42-31.7-11.81a5.77 5.77 0 00-4.09 2.69 25.53 25.53 0 00-2.58 7.29c-1.62 6.46-4.06 16.16-17.37 16.17h-.59c-1.72 0-3.68-.17-5.79-.33-9-.63-20.18-1.44-27.25 5.09-5.16 4.75-7.86 13.24-7.93 25.23z"
          />
          <path
            fill="currentColor"
            d="M222.41 337.92A117.93 117.93 0 11340.35 220a118.07 118.07 0 01-117.94 117.92zm0-225.64A107.71 107.71 0 10330.12 220a107.83 107.83 0 00-107.71-107.72z"
          />
          <path
            fill="currentColor"
            d="M89.3 298.72c-14.57 0-23.08-3.4-25.8-10.22-3.84-9.62 5.41-22.2 28.28-38.44a5.11 5.11 0 015.92 8.33C70.59 277.66 73 284.65 73 284.72c3.57 8.94 62.79 4.7 163.32-35.34 41.88-16.68 79.95-35.47 107.22-52.92 32.1-20.54 36.64-31.29 35.68-33.7-.82-2-9.54-6.33-39.71-1.59a5.11 5.11 0 01-1.59-10.09c30.16-4.75 46.79-2.16 50.79 7.9 4.43 11.1-8.55 26.18-39.67 46.09-27.79 17.79-66.48 36.89-108.94 53.81S156.41 288.51 124 294.7q-21 4.02-34.7 4.02z"
          />
        </svg>
      )
      break
    case 'play':
      IconSvg = (
        <svg viewBox="0 0 452.2 452.2" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M452.2 226.1a226.1 226.1 0 01-226.1 226.1A226.1 226.1 0 010 226.1 226.1 226.1 0 01226.1 0a226.1 226.1 0 01226.1 226.1zM161.24 105.6v241l188.7-131.5z"
            fill="currentColor"
          />
        </svg>
      )
      break
    case 'playV2':
      IconSvg = (
        <svg
          viewBox="0 0 25 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.75 19.2902V4.70985C5.75 3.94502 6.57366 3.46331 7.24026 3.83827L20.2005 11.1284C20.8802 11.5107 20.8802 12.4893 20.2005 12.8716L7.24026 20.1617C6.57366 20.5367 5.75 20.055 5.75 19.2902Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case 'salary':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            fill="currentColor"
            d="M422.5 270.6c-4.1 0-7.5 3.3-7.5 7.5 0 5.2-4.2 9.5-9.5 9.5-5.2 0-9.5-4.2-9.5-9.5 0-4.1-3.3-7.5-7.5-7.5s-7.5 3.3-7.5 7.5c0 13.4 10.9 24.4 24.4 24.4s24.4-10.9 24.4-24.4c.2-4.2-3.2-7.5-7.3-7.5z"
          />
          <path
            fill="currentColor"
            d="M492.4 271.8l-21-6.7c-2.7-.9-4.8-3-5.7-5.7-4.4-14.1-11.1-27.2-19.8-39.2-4-5.5-8.4-10.7-13.2-15.6 3.1-13.6 4.8-28.9 4.6-42.2-.3-19-4.1-30.1-11.6-34-4-2.1-16.3-8.5-82.8 21.9-1.6.7-3 1.6-4.4 2.6-4.5-1.2-9.1-2.3-13.7-3.3-.6-.1-1.1-.2-1.7-.3 5.4-11.8 8.5-24.5 9.1-37.7.2-4.1-3-7.6-7.1-7.8-4.1-.2-7.6 3-7.8 7.1-1 21.7-10 42.1-25.3 57.5-9.2 9.2-19.9 15.9-31.4 20.1-19.9-2.8-40.1-2.8-60 0-11.5-4.2-22.2-10.9-31.4-20.1-16.4-16.4-25.4-38.2-25.4-61.4 0-23.2 9-45 25.4-61.4C185.7 29 207.5 20 230.7 20s45 9 61.4 25.4c6.6 6.6 12 14.1 16.2 22.3 1.9 3.7 6.3 5.2 10 3.3 3.7-1.8 5.2-6.3 3.3-10-4.9-9.7-11.2-18.5-19-26.2C283.4 15.6 257.9 5 230.7 5S178 15.7 158.8 34.9C139.6 54.1 129 79.7 129 106.8s10.6 52.7 29.8 71.9c5.5 5.5 11.6 10.3 17.9 14.3-4.6 1.2-9.2 2.6-13.8 4.1-3.9 1.3-6 5.5-4.7 9.4 1.3 3.9 5.5 6 9.4 4.7 40.6-13.6 85.4-13.6 126 0 .8.3 1.6.4 2.4.4 3.1 0 6-2 7.1-5.1 1.3-3.9-.8-8.1-4.7-9.4-4.5-1.5-9.1-2.9-13.8-4.1 6.4-4 12.4-8.8 17.9-14.3 4.9-4.9 9.2-10.3 13-15.9 2.1.4 4.1.8 6.1 1.3 2.7.6 5.3 1.2 8 1.9-.1.3-.2.6-.2 1-3.6 17.2-3.4 32.5.7 45.3 3.7 11.5 10.3 20.9 19.8 27.8 11.1 8.1 24.5 11.6 36.7 11.6 9.1 0 17.6-2 23.8-5.5 7-4 12.9-12.3 17.5-24.9 2.1 2.5 4.2 5.1 6.1 7.7 7.8 10.7 13.7 22.4 17.6 34.9 2.3 7.3 8 13.1 15.3 15.5l21 6.7c5.5 1.8 9.2 6.8 9.2 12.6v34.8c0 5.8-3.7 10.8-9.2 12.6l-33.8 10.8c-5.4 1.7-10 5.4-12.9 10.5-13.3 22.9-34.1 41.9-62 56.4-3.2 1.7-5.5 4.7-6.1 8.2l-10.8 57.3c-.3 1.6-1.7 2.7-3.3 2.7h-35.2c-1.6 0-3-1.1-3.3-2.7l-6-31.7c-1.2-6.2-7-10.4-13.3-9.4-15.2 2.3-30.8 3.5-46.4 3.5-11.6 0-23.1-.6-34.1-1.9-6.1-.7-11.8 3.5-12.9 9.5l-5.7 30.1c-.3 1.6-1.7 2.7-3.3 2.7h-35.2c-1.6 0-3-1.1-3.3-2.7l-10.4-54.1c-.7-3.5-2.9-6.5-6-8.1-47.5-25.4-72.7-67.8-72.7-122.6 0-27.7 6.1-52.2 18-72.8 11.2-19.2 27.5-35.1 48.4-47.3 3.6-2.1 4.8-6.6 2.7-10.2-2.1-3.6-6.6-4.8-10.2-2.7-40.7 23.5-65.2 59.8-72 105.9-.7-.1-1.4-.1-2.2-.2.1-5-.8-10-2.7-14.9-4.3-10.7-13.2-18.5-22.6-19.8-7.4-1-14.5 2.2-19.4 8.6-7.1 9.4-5.9 16.8-3.7 21.4 3.8 7.7 13.4 13.2 29.4 16.6-.4.7-.9 1.3-1.5 2C26 303 14.9 305.6 7.6 305.9c-4.2.1-7.6 3.5-7.6 7.8 0 4.2 3.3 7.6 7.5 7.8h1.7c9.2 0 23.9-3.4 38-21.1 2.2-2.8 4-5.7 5.4-8.8 1.4.2 2.8.3 4.1.4-.3 4-.4 8.1-.4 12.3 0 31 7.4 58.7 22 82.2 13.4 21.7 32.7 39.5 57.3 52.8l10.1 52.6c1.6 8.6 9.2 14.9 17.9 14.9h35.2c8.8 0 16.3-6.2 17.9-14.9l5.1-27.2c10.7 1.1 21.8 1.7 33 1.7 15.4 0 30.7-1.1 45.7-3.2l5.4 28.7c1.6 8.6 9.2 14.9 17.9 14.9H359c8.8 0 16.3-6.2 17.9-14.9l10.5-55.8c29.8-15.7 52.2-36.4 66.7-61.5 1-1.8 2.7-3.1 4.5-3.7l33.8-10.8c11.7-3.7 19.6-14.5 19.6-26.8v-34.8c0-12.2-7.9-22.9-19.6-26.7zm-71.1-88.5c-2.9 24.5-10.6 45.5-18.3 49.9-8.8 5-29.1 5.9-44.3-5.2-15.2-11.2-20.3-31.2-14.7-58 .6-2.7 2.5-5 5.1-6.2 37.3-17.1 58.8-22.7 66.8-22.7 1.2 0 2.1.1 2.7.4 2.4 2.5 5.6 17 2.7 41.8zM20.9 266c-.8-1.6 1-4.4 2.2-5.9 1.8-2.4 3.5-2.9 4.8-2.9.3 0 .5 0 .8.1 3.4.5 8.2 4.2 10.8 10.5.6 1.5 1.4 4 1.6 7-10.4-2.1-18.4-5.2-20.2-8.8z"
          />
          <path
            fill="currentColor"
            d="M237.9 98.3V71.6c9.2.7 12.6 4.9 15.8 4.9 3.9 0 5.8-5 5.8-7.5 0-6.4-12.6-9.2-21.5-9.5V56c0-1.6-2-3-3.9-3-2.2 0-3.8 1.4-3.8 3v3.8c-12.5 1.3-25 7.9-25 24.4 0 16.8 13.1 21.5 25 25.7v30.9c-13.4-1.1-16.9-10.2-21.3-10.2-3.3 0-6 4.3-6 7.5 0 6.4 11 15.2 27.3 15.5v4.1c0 1.6 1.6 3 3.8 3 2 0 3.9-1.4 3.9-3v-4.5c14.2-2 23.9-10.9 23.9-27.1-.1-17.8-12.6-23.6-24-27.8zm-6.9-2.5c-7-2.6-12.6-5.4-12.6-12.9 0-6.8 5.3-10.1 12.6-11v23.9zm6.1 44.8v-27.7c6.4 2.8 11.6 6.4 11.6 14.7 0 7.5-4.5 11.7-11.6 13z"
          />
        </svg>
      )
      break
    case 'salaryV2':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 494.1 512">
          <path
            fill="currentColor"
            d="M300.5 193.3c3.9-2.4 7.2-5.7 9.5-9.6.9-1.4 2.4-2.2 4-2.2h24.2c2.7 0 4.8 2.2 4.8 4.8 0 .6-.1 1.1-.3 1.6-3.7 10.2-10.4 19.1-19.2 25.5-11.1 8-24.6 12.1-38.3 11.7-13.6.3-27-3.7-38.2-11.6-9.7-7-17-16.9-20.9-28.3-.7-1.9-2.5-3.2-4.5-3.2h-5.5c-2.6 0-4.8-2.1-4.8-4.8V171c0-2.6 2.2-4.8 4.8-4.8h1.5c2.6 0 4.8-2.1 4.8-4.8v-.4c0-2.6-2.1-4.8-4.8-4.8h-1.5c-2.6 0-4.8-2.1-4.8-4.8v-6.5c0-2.6 2.1-4.8 4.7-4.8h6c2 0 3.8-1.2 4.5-3.1 3.9-11.3 11.2-21.1 20.9-28.1 11.1-7.8 24.4-11.8 38-11.5 13.7-.4 27.1 3.8 38.3 11.8 8.8 6.5 15.4 15.4 19.2 25.6.9 2.5-.4 5.3-2.9 6.2-.5.2-1 .3-1.6.3h-24.3c-1.6 0-3.1-.8-4-2.2-2.3-3.9-5.6-7.2-9.5-9.5-4.7-2.7-10.1-4.1-15.5-4-5.4-.1-10.7 1.2-15.4 3.7-1.1.6-2.1 1.3-3.1 2-2.1 1.6-2.5 4.6-.9 6.8.9 1.2 2.2 1.9 3.7 1.9h14.5c2.6 0 4.8 2.1 4.8 4.8v6.5c0 2.6-2.1 4.8-4.8 4.8h-25.4c-2.6 0-4.8 2.1-4.8 4.8v.5c-.1 2.6 2 4.9 4.7 4.9h25.5c2.6 0 4.8 2.1 4.8 4.8v6.3c0 2.6-2.1 4.8-4.8 4.8h-15.3c-2.7 0-4.8 2.2-4.8 4.8 0 1.4.6 2.8 1.7 3.7 1.3 1 2.6 2 4 2.8 4.8 2.7 10.2 4 15.6 3.9 5.4.1 10.8-1.3 15.4-4.1z"
          />
          <path
            fill="currentColor"
            d="M166.7 289.8c-3.9 0-7.7-1.7-10.3-4.6-63.7-69-59.3-176.5 9.7-240.2s176.5-59.3 240.1 9.7c49.3 53.4 59.1 132.3 24.5 196.2-3.9 6.7-12.5 9-19.2 5.1-6.4-3.7-8.8-11.8-5.5-18.5 37.4-68.9 11.8-155-57.1-192.4s-155-11.8-192.4 57.1c-29 53.4-20.7 119.3 20.5 163.9 5.3 5.7 4.9 14.6-.8 19.8-2.5 2.4-5.9 3.8-9.5 3.9zM99.7 512c-8.3 0-16-4.4-20.3-11.6l-76.1-130c-6.5-11.1-2.8-25.5 8.3-32.1l57.8-33.7c11.2-6.5 25.6-2.8 32.1 8.4v.1l76.1 129.8c3.1 5.4 4 11.8 2.4 17.8-1.5 6-5.4 11.2-10.8 14.3l-57.7 33.8c-3.5 2.1-7.6 3.2-11.8 3.2zm-2.4-27.4zM29.9 360.2l71.4 122 49.7-29.1-71.5-122-49.6 29.1zm-2.4-4zm49.7-29.1z"
          />
          <path
            fill="currentColor"
            d="M312.3 455.4h-152c-5 0-9.6-2.6-12.1-6.9l-11-18.8c-3.9-6.7-1.7-15.3 5-19.2 6.7-3.9 15.3-1.7 19.2 5l7 11.9h143.8c6.2 0 28.5-2 54.3-27.8l91.1-91.1c11.1-11.1 11.1-28.9.2-40.1l-.2-.2-.5-.5c-11.1-11-29-11-40.1 0l-75.3 73.7c-7.2 10.3-18.9 16.5-31.5 16.5h-69.8c-7.8 0-14-6.3-14-14s6.3-14 14-14h69.8c3.4 0 6.6-1.7 8.5-4.6.2-.2.3-.5.5-.7.8-1.1 1.7-2.2 2.7-3.1l75.4-73.9c22-21.8 57.5-21.8 79.5 0l.3.2.5.5c22.1 22.1 22.1 57.9 0 79.9l-91.1 91.1c-32.6 32.6-62.8 36.1-74.2 36.1zm29.6-114.3z"
          />
          <path
            fill="currentColor"
            d="M149.3 436.4c-5 0-9.6-2.6-12.1-7l-51.6-88.1c-3.1-5.3-2.4-12.1 1.8-16.6l30.7-33.1c16.1-20.2 44.9-31.3 77.4-29.8h114.7c27.5 0 51.2 19.7 56.2 46.7.8 4.6-.6 9.3-4 12.6l-20.7 20.2c-7.2 10.3-18.9 16.5-31.5 16.5h-69.8c-7.8 0-14-6.3-14-14s6.3-14 14-14h69.8c3.4 0 6.6-1.7 8.5-4.6.2-.2.3-.5.5-.7.8-1.1 1.7-2.2 2.7-3.1l14.8-14.5c-4.7-10.4-15.1-17.1-26.5-17.1H194.5c-23.8-1.2-44.1 6.1-54.5 19.4-.2.3-.5.6-.8.9l-24 25.9 46.4 79.1c4 6.7 1.8 15.3-4.9 19.3-2.3 1.3-4.8 2-7.4 2zM341.9 341z"
          />
        </svg>
      )
      break
    case 'search':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 244.04 252">
          <path
            fill="currentColor"
            d="M237.54 252a6.49 6.49 0 01-4.68-2l-81.05-84.17a6.5 6.5 0 119.36-9L242.22 241a6.5 6.5 0 01-4.68 11z"
          />
          <path
            fill="currentColor"
            d="M94.84 189.67a94.84 94.84 0 1194.83-94.83 94.94 94.94 0 01-94.83 94.83zm0-176.67a81.84 81.84 0 1081.83 81.84A81.93 81.93 0 0094.84 13z"
          />
          <path
            fill="currentColor"
            d="M144.76 137.15a6.38 6.38 0 01-3.79-1.22 6.5 6.5 0 01-1.47-9.07A54.38 54.38 0 0082 42.39a6.5 6.5 0 01-3.2-12.6 67.38 67.38 0 0171.27 104.66 6.48 6.48 0 01-5.31 2.7z"
          />
        </svg>
      )
      break
    case 'shirt':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 452.2 452.2">
          <path
            fill="currentColor"
            d="M266.65 360.55h-10.22v-38.07a5.11 5.11 0 015.11-5.11h42.13v10.22h-37zM225.75 160.28a62.19 62.19 0 01-53.68-31l8.85-5.11a51.75 51.75 0 0089.66 0l8.86 5.12a62.21 62.21 0 01-53.69 30.99z"
          />
          <path
            fill="currentColor"
            d="M261.54 365.66H147.83a5.11 5.11 0 01-5.11-5.11V251.66a5.1 5.1 0 01-2.61 2.92 5.17 5.17 0 01-3.9.22l-47.6-16.63a5.12 5.12 0 01-3.14-6.51l25.72-73.61c.71-3.43 4.55-10.69 22.91-18.88l7.12-3.19C167.36 124.2 194.38 112 225.75 112s58.4 12.18 84.53 23.95l7.12 3.19c18.36 8.19 22.21 15.45 22.92 18.88L366 231.66a5.12 5.12 0 01-3.14 6.51L315.3 254.8a5.17 5.17 0 01-3.9-.22 5.1 5.1 0 01-2.61-2.92v70.82a5.12 5.12 0 01-1.68 3.79L265 364.34a5.11 5.11 0 01-3.46 1.32zm-108.6-10.22h106.64l39-35.23v-98.72a5.11 5.11 0 019.93-1.68l8.27 23.65 37.93-13.26-24.19-69.2a5.91 5.91 0 01-.19-.69c-.27-.61-2.8-5.44-17.09-11.81l-7.16-3.21c-25.15-11.33-51.15-23.05-80.33-23.05S170.57 134 145.42 145.3l-7.16 3.21c-14.28 6.37-16.82 11.2-17.09 11.8a5.56 5.56 0 01-.19.7l-24.17 69.2 37.93 13.25 8.26-23.65a5.11 5.11 0 019.93 1.68z"
          />
          <path
            fill="currentColor"
            d="M226.08 121.73a5.11 5.11 0 01-5.11-5.12 14.37 14.37 0 00-6.42-11.67 16.05 16.05 0 01-3.43-3.47 23.66 23.66 0 01-4.89-14.53 24.05 24.05 0 0148.1 0 5.12 5.12 0 01-10.23 0 13.82 13.82 0 10-27.64 0 13.67 13.67 0 002.88 8.45 6 6 0 001.08 1.18c6.87 4.88 10.78 12.18 10.77 20.05a5.11 5.11 0 01-5.11 5.11zM189.22 244.78a5.12 5.12 0 01-2-.42l-20.73-8.93a5.13 5.13 0 01-3.09-4.7v-35a5.11 5.11 0 015.11-5.12h41.38a5.11 5.11 0 015.11 5.12v35a5.11 5.11 0 01-3.08 4.69l-20.65 8.94a5.06 5.06 0 01-2.05.42zm-15.62-17.41l15.62 6.73 15.54-6.73V200.8H173.6z"
          />
        </svg>
      )
      break
    case 'star':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 235.85 228">
          <path
            fill="currentColor"
            d="M186.75 228a6.4 6.4 0 01-3.06-.77l-65.76-35.08-65.77 35.08a6.5 6.5 0 01-9.47-6.81L55.27 146 1.93 93.19a6.5 6.5 0 013.62-11l73.64-10.9 32.89-67.63a6.5 6.5 0 0111.69 0l32.89 67.63 73.64 10.85a6.5 6.5 0 013.62 11L180.58 146l12.58 74.46a6.51 6.51 0 01-6.41 7.58zM20.32 93.11l45.13 44.63a10.22 10.22 0 012.88 9l-10.62 62.8L113.12 180a10.41 10.41 0 019.62 0l55.4 29.56-10.62-62.86a10.19 10.19 0 012.89-9l45.12-44.63-62.22-9.18a10.22 10.22 0 01-7.7-5.63l-27.68-56.9-27.69 56.93a10.21 10.21 0 01-7.7 5.64zm96.29 98.33z"
          />
        </svg>
      )
      break
    case 'stopwatch':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            fill="currentColor"
            d="M419.8 170.6l21.5-21.5c11.7-11.7 11.7-30.7 0-42.4s-30.7-11.7-42.4 0l-23 23c-24-16.7-51.3-28.3-79.9-33.8V66h20c5.5 0 10-4.5 10-10V30c0-16.5-13.5-30-30-30h-80c-16.5 0-30 13.5-30 30v26c0 5.5 4.5 10 10 10h20v29.8c-28.6 5.5-56 17.1-79.9 33.8l-23-23c-11.7-11.7-30.7-11.7-42.4 0s-11.7 30.7 0 42.4l21.5 21.5C62.3 207.8 46 254.1 46 302c0 115.8 94.2 210 210 210s210-94.2 210-210c0-47.9-16.3-94.2-46.2-131.4zm-6.7-49.8c3.9-3.9 10.2-3.9 14.1 0 3.9 3.9 3.9 10.2 0 14.1l-20.7 20.7c-4.7-4.8-9.5-9.3-14.6-13.7l21.2-21.1zM206 30c0-5.5 4.5-10 10-10h80c5.5 0 10 4.5 10 10v16H206V30zm70 36v26.9c-13.3-1.2-26.7-1.2-40 0V66h40zM84.8 120.8c3.9-3.9 10.2-3.9 14.1 0l21.1 21.1c-5.1 4.3-10 8.9-14.6 13.7l-20.7-20.7c-3.8-3.9-3.8-10.2.1-14.1zM256 492c-104.8 0-190-85.2-190-190 0-46.2 16.8-90.7 47.2-125.4 8.4-9.5 17.8-18.3 27.8-25.9 25.2-19.2 55.1-31.9 86.4-36.6 9.4-1.4 19-2.1 28.5-2.1s19.2.7 28.5 2.1c31.3 4.7 61.2 17.4 86.4 36.6 10.1 7.7 19.4 16.4 27.8 25.9C429.2 211.3 446 255.8 446 302c0 104.8-85.2 190-190 190z"
          />
          <path
            fill="currentColor"
            d="M256 332c16.5 0 30-13.5 30-30 0-13-8.4-24.2-20-28.3V202c0-5.5-4.5-10-10-10s-10 4.5-10 10v71.7c-11.6 4.1-20 15.2-20 28.3 0 16.5 13.5 30 30 30zm0-40c5.5 0 10 4.5 10 10s-4.5 10-10 10-10-4.5-10-10 4.5-10 10-10z"
          />
          <path
            fill="currentColor"
            d="M362.5 196.5c-.2-.2-.3-.4-.5-.5-.2-.2-.4-.4-.6-.5-17.6-17.4-39.4-30.3-63-37.3-5.3-1.6-10.9 1.5-12.4 6.8s1.5 10.9 6.8 12.4c17.5 5.2 33.8 14.1 47.8 26l-6.7 6.7c-3.9 3.9-3.9 10.2 0 14.1 2 2 4.5 2.9 7.1 2.9 2.6 0 5.1-1 7.1-2.9l6.8-6.8c18.1 21 28.8 46.9 30.9 74.5H376c-5.5 0-10 4.5-10 10s4.5 10 10 10h9.6c-2.1 27.6-12.8 53.5-30.9 74.5l-6.8-6.8c-3.9-3.9-10.2-3.9-14.1 0-3.9 3.9-3.9 10.2 0 14.1l6.8 6.8c-21 18.1-46.9 28.8-74.5 30.9V422c0-5.5-4.5-10-10-10s-10 4.5-10 10v9.6c-27.6-2.1-53.5-12.8-74.5-30.9l6.8-6.8c3.9-3.9 3.9-10.2 0-14.1-3.9-3.9-10.2-3.9-14.1 0l-6.8 6.8c-18.1-21-28.8-46.9-30.9-74.5h9.6c5.5 0 10-4.5 10-10s-4.5-10-10-10h-9.6c2.1-27.6 12.8-53.5 30.9-74.5l6.8 6.8c2 2 4.5 2.9 7.1 2.9 2.6 0 5.1-1 7.1-2.9 3.9-3.9 3.9-10.2 0-14.1l-6.7-6.7c13.9-11.9 30.3-20.9 47.8-26 5.3-1.6 8.3-7.1 6.8-12.4s-7.1-8.3-12.4-6.8c-23.6 7-45.4 19.9-63 37.3-.2.2-.4.4-.6.5-.2.2-.3.4-.5.5-28 28.3-43.5 65.7-43.5 105.5s15.4 77.2 43.5 105.5c.2.2.3.4.5.5.2.2.4.3.5.5 28.3 28 65.7 43.5 105.5 43.5s77.2-15.4 105.5-43.5c.2-.2.4-.3.5-.5.2-.2.3-.4.5-.5 28-28.3 43.5-65.7 43.5-105.5-.4-40-15.8-77.4-43.9-105.7z"
          />
          <path
            fill="currentColor"
            d="M256 172c5.5 0 10-4.5 10-10s-4.5-10-10-10-10 4.5-10 10 4.5 10 10 10z"
          />
        </svg>
      )
      break
    case 'stopwatchV2':
      IconSvg = <BriefcaseIcon />
      break
    case 'sustainable':
      IconSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 452.2 452.2">
          <path
            fill="currentColor"
            d="M140.54 337.17a5.12 5.12 0 01-4.41-2.53L94.77 264a5.11 5.11 0 011.83-7l31.33-18.35a5.1 5.1 0 017 1.83l41.36 70.59a5.13 5.13 0 01-1.83 7l-31.33 18.35a5.13 5.13 0 01-2.59.75zm-34.36-73.88l36.18 61.77 22.51-13.18-36.19-61.78z"
          />
          <path
            fill="currentColor"
            d="M254.87 263.72H217a5.12 5.12 0 010-10.23h37.91a13.21 13.21 0 0013.19-13.19v-.37a13.21 13.21 0 00-13.19-13.2h-62.78c-9.67-.45-21.84 1.85-27.82 9.7-.1.13-.21.25-.31.37l-21.71 23.48a5.11 5.11 0 01-7.5-6.94L156.33 230c7.16-9.21 20.57-14.3 36-13.51h62.5a23.45 23.45 0 0123.42 23.42v.37a23.45 23.45 0 01-23.38 23.44z"
          />
          <path
            fill="currentColor"
            d="M287.27 290.58a5.12 5.12 0 01-3.61-8.73l49.48-49.48a12.87 12.87 0 000-18.19l-.24-.24a12.88 12.88 0 00-18.2 0l-41.05 40.23a5.11 5.11 0 11-7.15-7.3l41-40.19a23.06 23.06 0 0132.6 0l.25.24a23.08 23.08 0 010 32.65l-49.48 49.49a5.1 5.1 0 01-3.6 1.52z"
          />
          <path
            fill="currentColor"
            d="M256 306.41H164.58a5.11 5.11 0 110-10.22h90.9c.46.06 12.83 1 28.18-14.33a5.11 5.11 0 017.23 7.23c-15.83 15.81-30.07 17.32-34.89 17.32zM260.51 180.25a50.31 50.31 0 01-29-9.12 5.14 5.14 0 01-2.14-3.53 49.76 49.76 0 01-.47-6.55 50.62 50.62 0 0179.61-41.53 5.11 5.11 0 012.14 3.54 49.74 49.74 0 01.47 6.54 50.71 50.71 0 01-50.61 50.65zM239.3 164a40.06 40.06 0 0021.21 6 40.48 40.48 0 0040.43-40.43c0-.93-.05-1.89-.14-2.94a40.06 40.06 0 00-21.21-6 40.47 40.47 0 00-40.42 40.43c0 .94.04 1.88.13 2.94zM183 197.33a40 40 0 01-38.78-30.08 5.13 5.13 0 01.91-4.41 40 40 0 0170.47 14.5 5.14 5.14 0 01-.91 4.4A39.82 39.82 0 01183 197.33zm-28.14-30.19a29.8 29.8 0 0050.1 10.3 29.8 29.8 0 00-50.1-10.3z"
          />
          <path
            fill="currentColor"
            d="M224.88 226.73a5.11 5.11 0 01-5.12-5.11v-39.77a22.15 22.15 0 0110.55-18.94L270.48 138a5.11 5.11 0 115.39 8.68l-40.17 24.91a12 12 0 00-5.7 10.26v39.77a5.11 5.11 0 01-5.12 5.11z"
          />
          <path
            fill="currentColor"
            d="M224.88 203.62a5.11 5.11 0 01-5.12-5.11c0-10.43-11.09-13.35-11.56-13.47l-33-7.08a5.11 5.11 0 012.15-10l33.11 7.12c6.82 1.63 19.5 8.6 19.5 23.43a5.11 5.11 0 01-5.08 5.11z"
          />
        </svg>
      )
      break
    case 'upload':
      IconSvg = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.50008 11.6667C2.96032 11.6667 3.33341 12.0398 3.33341 12.5001V15.8334C3.33341 16.0544 3.42121 16.2664 3.57749 16.4227C3.73377 16.579 3.94573 16.6667 4.16675 16.6667H15.8334C16.0544 16.6667 16.2664 16.579 16.4227 16.4227C16.5789 16.2664 16.6667 16.0544 16.6667 15.8334V12.5001C16.6667 12.0398 17.0398 11.6667 17.5001 11.6667C17.9603 11.6667 18.3334 12.0398 18.3334 12.5001V15.8334C18.3334 16.4965 18.07 17.1323 17.6012 17.6012C17.1323 18.07 16.4965 18.3334 15.8334 18.3334H4.16675C3.50371 18.3334 2.86782 18.07 2.39898 17.6012C1.93014 17.1323 1.66675 16.4965 1.66675 15.8334V12.5001C1.66675 12.0398 2.03984 11.6667 2.50008 11.6667Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.41074 1.91083C9.73618 1.58539 10.2638 1.58539 10.5893 1.91083L14.7559 6.07749C15.0814 6.40293 15.0814 6.93057 14.7559 7.256C14.4305 7.58144 13.9028 7.58144 13.5774 7.256L10 3.67859L6.42259 7.256C6.09715 7.58144 5.56951 7.58144 5.24408 7.256C4.91864 6.93057 4.91864 6.40293 5.24408 6.07749L9.41074 1.91083Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.0001 1.66675C10.4603 1.66675 10.8334 2.03984 10.8334 2.50008V12.5001C10.8334 12.9603 10.4603 13.3334 10.0001 13.3334C9.53984 13.3334 9.16675 12.9603 9.16675 12.5001V2.50008C9.16675 2.03984 9.53984 1.66675 10.0001 1.66675Z"
            fill="currentColor"
          />
        </svg>
      )
      break
    case 'user':
      IconSvg = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.8">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.72039 12.8871C4.50179 12.1057 5.5616 11.6667 6.66667 11.6667H13.3333C14.4384 11.6667 15.4982 12.1057 16.2796 12.8871C17.061 13.6685 17.5 14.7283 17.5 15.8334V17.5001C17.5 17.9603 17.1269 18.3334 16.6667 18.3334C16.2064 18.3334 15.8333 17.9603 15.8333 17.5001V15.8334C15.8333 15.1704 15.5699 14.5345 15.1011 14.0656C14.6323 13.5968 13.9964 13.3334 13.3333 13.3334H6.66667C6.00363 13.3334 5.36774 13.5968 4.8989 14.0656C4.43006 14.5345 4.16667 15.1704 4.16667 15.8334V17.5001C4.16667 17.9603 3.79357 18.3334 3.33333 18.3334C2.8731 18.3334 2.5 17.9603 2.5 17.5001V15.8334C2.5 14.7283 2.93899 13.6685 3.72039 12.8871Z"
              fill="#637381"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.99998 3.33341C8.61927 3.33341 7.49998 4.4527 7.49998 5.83341C7.49998 7.21413 8.61927 8.33341 9.99998 8.33341C11.3807 8.33341 12.5 7.21413 12.5 5.83341C12.5 4.4527 11.3807 3.33341 9.99998 3.33341ZM5.83331 5.83341C5.83331 3.53223 7.69879 1.66675 9.99998 1.66675C12.3012 1.66675 14.1666 3.53223 14.1666 5.83341C14.1666 8.1346 12.3012 10.0001 9.99998 10.0001C7.69879 10.0001 5.83331 8.1346 5.83331 5.83341Z"
              fill="#637381"
            />
          </g>
        </svg>
      )
      break
    case 'home':
      IconSvg = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
          className="nz sb up"
        >
          <path
            fillRule="evenodd"
            d="M9.293 2.293a1 1 0 011.414 0l7 7A1 1 0 0117 11h-1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-6H3a1 1 0 01-.707-1.707l7-7z"
            clipRule="evenodd"
          />
        </svg>
      )
      break
    default:
      return null
  }

  return (
    <svg
      className={`${colorClass} ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
    >
      {IconSvg}
    </svg>
  )
}

export default Icon
